module.exports = __webpack_public_path__ + "img/PriceQuotationJobOrders.43c9ef5f.svg";